export const tenantJobLabel = {
  pageSize: {
    width: 283.5,
    height: 226.77
  },
  pageOrientation: 'landscape',
  pageMargins: [ 0, 27, 0, 0 ],
  info: {
    title: '',
    author: 'Demo GmbH, Berlin',
    subject: '',
    revison: 'Rev 01/2026',
  },
  background: function(currentPage: number, pageCount: number) {
    return [
      {
        svg:
          '<svg x="190" viewBox="0 0 300 200">' +
          '<style type="text/css">' +
            '.dl-bg{fill:#0057a8;}' +
            '.dl-acc{fill:#f0a500;}' +
            '.dl-txt{fill:#ffffff;font-family:Helvetica,Arial,sans-serif;font-size:13px;font-weight:bold;}' +
            '.dl-sub{fill:#f0a500;font-family:Helvetica,Arial,sans-serif;font-size:7px;letter-spacing:1.5px;}' +
          '</style>' +
          '<rect class="dl-bg" x="179.9" y="0" width="52.6" height="56.2"/>' +
          '<rect class="dl-acc" x="179.9" y="46" width="52.6" height="10.2"/>' +
          '<text class="dl-txt" transform="translate(6 38)">Demo GmbH</text>' +
          '<text class="dl-sub" transform="translate(6 50)">MUSTERFIRMA BERLIN</text>' +
          '</svg>',
        fit: [ 200, 80 ]
      }
    ]
  },
  content: [
    {
      layout: 'noBorders',
      table: {
        headerRows: 0,
        widths: [ 'auto', 'auto' ],
        body: [
          [ { text: 'Job Demo:', style: 'fett' }, { text: '26.0001.0001.1' } ],
          [ { text: 'Best.-Nr. Knd:', style: 'fett' }, { text: 'MK-2026-00042' } ],
          [ { text: 'Bauteilname:', style: 'fett' }, { text: 'Musterbaugruppe Typ A' } ],
          [ { text: 'Menge:', style: 'fett' }, { text: '10' } ],
          [ { text: 'Zeichnungsnr.:', style: 'fett' }, { text: 'DWG-2026-001 Ausgabe 01 / 05-26' } ],
          [ { text: 'Material:', style: 'fett' }, { text: 'S235JR, 1.0038 +N' } ],
          [ { text: 'Charge:', style: 'fett' }, { text: '' } ],
          [ { text: 'Ser.-Nr.:', style: 'fett' }, { text: '' } ]
        ]
      },
      style: 'normal',
      margin: [ 20, 5 ]
    },
    {
      table: {
        headerRows: 1,
        widths: [ '30%', '35%', '35%' ],
        body: [
          [
            { text: '' }, { text: 'Datum' }, { text: 'Unterschrift' },
          ],
          [ { text: 'Freigabe' }, ' ', ' ' ],
          [ { text: 'Sperrung' }, ' ', ' ' ],
          [ [ 'Freigabe', { text: 'nach Sperrung', style: 'small' } ], ' ', ' ' ]
        ]
      },
      style: 'table',
      margin: [ 20, 0 ]
    },
  ],

  styles: {
    header: {
      fontSize: 10,
      bold: true
    },
    table: {
      fontSize: 9,
      bold: false
    },
    normal: {
      fontSize: 9,
      bold: false
    },
    fett: {
      fontSize: 9,
      bold: true
    },
    small: {
      fontSize: 6,
      bold: false
    }
  }
};
